import React from "react";
import moment from "moment-timezone";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import TimeTotal from "../helpers/TimeTotal.jsx";

const CardHeader = ({ item }) => {
  const formatDateWithLabel = (dateValue) => {
    // The group key is the entry's localDate — a plain "YYYY-MM-DD" calendar
    // day with no timezone. Compare it to the VIEWER's own today as another
    // plain day string: converting either side through a zone is what made an
    // entry logged today read as "Yesterday" for anyone whose zone differed
    // from the tenant's.
    const inputDay = moment(dateValue, "YYYY-MM-DD", true);
    if (!inputDay.isValid()) return "";

    const key = inputDay.format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");

    if (key === today) return "Today";
    if (key === yesterday) return "Yesterday";
    return inputDay.format("ddd, MMM D");
  };

  return (
    <Card.Header>
      <Row className="card-header-sec">
        <Col className="card-header-date">
          {formatDateWithLabel(item?.[0])}
        </Col>
        <div className="separation-head"></div>
        <Col className="card-timer">
          <TimeTotal item={item} />
        </Col>
      </Row>
    </Card.Header>
  );
};

export default CardHeader;